import { Container } from "@mui/material";
import QuotationsList from "./QuotationsList";
import Tabs from "components/templates/Tabs";
import Button from "components/atoms/Button";
import { useNavigate } from "react-router-dom";
import Banner from "components/templates/Banner";
import { quotationActions } from "redux/slices/quotation";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import BlockComponent from "components/organisms/BlockComponent/BlockComponent";
export default function Quotations() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const tab: any = useAppSelector((state) => state.quotation.tab);
  return (
    <div>
      <Container maxWidth="lg">
        <Banner heading="Quotations">
          <BlockComponent permission={"quotation:add"}>
            <Button
              variant="contained"
              onClick={() => navigate("/add-rfq")}
            >
              Add Quotation
            </Button>
          </BlockComponent>
        </Banner>
        <Tabs
          value={tab}
          showRefresh={tab< 11}
          onRefresh={() =>dispatch(quotationActions.refresh())}
          onChange={(tab) => dispatch(quotationActions.setTab(tab))}
          tabs={[
            {
              label: "Open",
              element: <QuotationsList type="open" showFilters/>,
            },
            {
              label: "Close",
              element: <QuotationsList type="close" showFilters />,
            },
           
           
          ]}
        />
      </Container>
    </div>
  );
}
